module.exports = __webpack_public_path__ + "img/attachment-icon-v2.b93ee0f1.svg";